import {createEntityAdapter, EntityAdapter} from "@ngrx/entity";
import {createReducer, on} from "@ngrx/store";
import * as UserRolesActions from "./user-roles.actions";
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {UserRole} from '@association/_common/models/user-role.models';
import {EntityStateModel} from '@common/models/entity-state.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const userRoleFeatureKey = 'userRole';

export function sortEntities(a: UserRole, b: UserRole) {
    if (a.adminRole === true && b.adminRole !== true) {
        return -1;
    }
    if (a.adminRole !== true && b.adminRole === true) {
        return 1;
    }

    if (a.name && b.name) {
        return a.name.localeCompare(b.name);
    }

    return 0;
}

export const adapter: EntityAdapter<UserRole> = createEntityAdapter<UserRole>({
    sortComparer: sortEntities
});

export type UserRoleState = EntityStateModel<UserRole, any>;

export const initialState: UserRoleState = adapter.getInitialState({
    listLoading: 'listLoading',
    pagination: {},
    itemsLoading: []
});

export const userRoleReducer = createReducer(
    initialState,

    on(UserRolesActions.LoadList, (state, action) => ({
        ...state,
        listLoading: action.payload.loading
    })),

    on(UserRolesActions.LoadListSuccess, (state, action) => {
        return adapter.setAll(action.payload.items, {
            ...state,
            pagination: action.payload.pagination,
            listLoading: undefined
        });
    }),

    on(UserRolesActions.LoadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(UserRolesActions.SetLoading, (state, action) => ({
        ...state,
        listLoading: action.payload
    })),

    on(UserRolesActions.SetItemsLoading, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id, action.payload.isStart)
    })),

    on(UserRolesActions.UpdateItemSuccess, (state, action) => {
        return adapter.setOne(action.payload!, {
            ...state,
            itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false),
            pagination: {...state.pagination, totalElements: StoredComponentHelperService.setTotalElements(action.payload.id!, state.pagination, state?.ids)}
        });
    }),

    on(UserRolesActions.DeleteItem, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, true)
    })),

    on(UserRolesActions.DeleteItemSuccess, (state, action) => {
        return adapter.removeOne(action.payload.id!, {
            ...state,
            itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false),
            pagination: {...state.pagination, totalElements: StoredComponentHelperService.setTotalElements(action.payload.id!, state.pagination, state?.ids, true)}
        });
    }),

    on(UserRolesActions.DeleteItemFailure, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false)
    })),

    on(UserRolesActions.SetInitialState, SetAllInitialStates, () => ({...initialState}))
);

export const {selectAll: selectAllEntities} = adapter.getSelectors();
